<div class="heading" padding-top-large padding-bottom-large>
  {{ 'rtr.homepage.referrals' | translate }}
</div>

<div
  *ngIf="applications.length || searchControl.value || isLoading"
  class="filters"
  layout
  layout-wrap
  layout-space-between
  margin-bottom-small-x
>
  <rt-form-field class="search" margin-bottom-small>
    <rt-input
      [formControl]="searchControl"
      [placeholder]="'rtr.common.search' | translate"
      [hasClearButton]="true"
      (reset)="searchControl.setValue('')"
      variant="rounded"
    >
      <rt-icon prefix name="search"></rt-icon>
    </rt-input>
  </rt-form-field>
  <ng-container *ngTemplateOutlet="sortSection"></ng-container>
</div>

<ng-container *ngIf="applications.length; else noApplications">
  <rtr-referrals-list
    *ngIf="!referralStatusVisible; else statusVisible"
    [applications]="applications"
    [showStatus]="false"
    [rewardsVisible]="rewardsVisible"
    [title]="'rtr.referrals.all_referrals' | translate"
    [collapseEnabled]="false"
  ></rtr-referrals-list>
</ng-container>

<ng-template #statusVisible>
  <rtr-referrals-list
    [applications]="filteredApplications[ReferralStatus.InReview]"
    [showStatus]="true"
    [rewardsVisible]="rewardsVisible"
    [title]="'rtr.referrals.in_progress' | translate"
    [tooltipText]="'rtr.referrals.tooltip.default' | translate"
    margin-bottom-large
  ></rtr-referrals-list>
  <rtr-referrals-list
    [applications]="filteredApplications[ReferralStatus.ProcessComplete]"
    [showStatus]="true"
    [rewardsVisible]="rewardsVisible"
    [title]="'rtr.referrals.completed' | translate"
    [tooltipText]="'rtr.referrals.tooltip.completed' | translate"
    margin-bottom-large
  ></rtr-referrals-list>
  <rtr-referrals-list
    [applications]="filteredApplications[ReferralStatus.Claimed]"
    [showStatus]="true"
    [rewardsVisible]="rewardsVisible"
    [title]="'rtr.referrals.successful_referrals' | translate"
    [tooltipText]="'rtr.referrals.tooltip.success' | translate"
  ></rtr-referrals-list
></ng-template>

<ng-template #sortSection>
  <rt-button
    (click)="manageOpenDropdown.open = !manageOpenDropdown.open"
    rt-overlay-origin
    margin-left-small
    [dropdownOpened]="manageOpenDropdown.open"
    [class.dropdownOpened]="manageOpenDropdown.open"
    #manageOpenDropdownTrigger="rtOverlayOrigin"
    variant="secondary"
  >
    <rt-icon
      [name]="sortOrder$.value === SortDirection.Asc ? 'sort-ascending' : 'sort-descending'"
    ></rt-icon>
    <span>{{ sortBy$.value?.label }}</span>
  </rt-button>
  <ng-template
    (backdropClick)="manageOpenDropdown.open = false"
    [origin]="$any(manageOpenDropdownTrigger)"
    [width]="200"
    #manageOpenDropdown="rtConnectedOverlay"
    rt-connected-overlay
    hasBackdrop
  >
    <rt-dropdown>
      <rt-dropdown-header> {{ 'rtr.referrals.sort_by.header' | translate }} </rt-dropdown-header>
      <rt-dropdown-item
        *ngFor="let option of sortOptions$ | async; trackBy: $any(trackByValue)"
        (click)="changeSortFilter(option)"
      >
        <rt-icon
          *ngIf="sortBy$.value.value === option.value"
          [name]="sortOrder$.value === SortDirection.Asc ? 'sort-ascending' : 'sort-descending'"
        ></rt-icon>
        {{ option.label }}
      </rt-dropdown-item>
    </rt-dropdown>
  </ng-template>
</ng-template>

<ng-template #noApplications>
  <rt-empty-state
    *ngIf="searchControl.value && !isLoading"
    [title]="'rtr.referrals.empty_state.filters.header' | translate"
    [desc]="'rtr.referrals.empty_state.filters.description' | translate"
    [backgroundFade]="true"
    variant="with-background default v-centered"
    icon="favorite-border"
  >
    <rt-button variant="secondary" (click)="searchControl.reset()">
      {{ 'rtr.referrals.empty_state.filters.clear' | translate }}
    </rt-button>
  </rt-empty-state>
  <rt-empty-state
    *ngIf="!searchControl.value && !isLoading"
    [title]="'rtr.referrals.empty_state.header' | translate"
    [desc]="'rtr.referrals.empty_state.description' | translate"
    [backgroundFade]="true"
    variant="with-background default v-centered"
    icon="favorite-border"
  >
    <rt-button variant="secondary" routerLink="/">{{
      'rtr.referrals.see_open_jobs' | translate
    }}</rt-button>
  </rt-empty-state>
  <rt-spinner *ngIf="isLoading" margin-top-large-x></rt-spinner>
</ng-template>
